// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"N9-z","disabled":"O9-z","label":"P9-z"};